import script from "./wxLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./wxLogin.vue?vue&type=script&setup=true&lang=js"

import "./wxLogin.vue?vue&type=style&index=0&id=e172b0d2&lang=scss&scoped=true"

import exportComponent from "D:\\a-mydemo\\houlang\\gs-demo\\keymemo-demo\\keymemory-pc-login\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e172b0d2"]])

export default __exports__